import React from "react";
import { ScrollView, StyleSheet, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { useRoute } from "@react-navigation/native";

import Container from "../../components/Container";
import Heading from "../../components/Heading";
import Text from "../../components/Text";
import Button from "../../components/Button";
import StickyFooter from "../../components/StickyFooter";
import { colors, fonts } from "../../theme";

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.black,
    flex: 1,
  },
  scrollView: {
    padding: 20,
  },
  storeName: {
    fontFamily: "RobotoMono_400Regular",
    color: colors.yellow,
    textTransform: "uppercase",
    fontSize: 12,
    letterSpacing: 2,
    marginBottom: 14,
  },
  title: {
    color: colors.white,
    marginBottom: 10,
  },
  description: {
    color: colors.midGrey,
    lineHeight: 21,
    marginBottom: 28,
  },
  step: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 16,
  },
  stepNumber: {
    fontFamily: "RobotoMono_400Regular",
    color: colors.yellow,
    fontSize: 12,
    width: 22,
    marginTop: 1,
  },
  stepText: {
    flex: 1,
    color: colors.midGrey,
    lineHeight: 20,
  },
});

type Props = { navigation: any };

const BookingLandingScreen: React.FC<Props> = ({ navigation }) => {
  const { params } = useRoute<any>();
  const store = params?.store;

  return (
    <SafeAreaView style={styles.container} edges={["right", "bottom", "left"]}>
      <Container>
        <ScrollView style={styles.scrollView}>
          <Text style={styles.storeName}>{store?.name}</Text>
          <Heading size="xl" style={styles.title}>
            Book your appointment
          </Heading>
          <Text style={styles.description}>
            Pick a service and a time that works for you. Takes about two
            minutes.
          </Text>

          <View style={styles.step}>
            <Text style={styles.stepNumber}>01</Text>
            <Text style={styles.stepText}>
              Choose your service and artist
            </Text>
          </View>
          <View style={styles.step}>
            <Text style={styles.stepNumber}>02</Text>
            <Text style={styles.stepText}>
              Pick a day and an open time slot
            </Text>
          </View>
          <View style={styles.step}>
            <Text style={styles.stepNumber}>03</Text>
            <Text style={styles.stepText}>
              Confirm with your name, email, and phone
            </Text>
          </View>
        </ScrollView>
      </Container>
      <StickyFooter>
        <Button
          title="Start booking"
          onPress={() =>
            navigation.navigate("ServiceTypeSelection", { store })
          }
        />
      </StickyFooter>
    </SafeAreaView>
  );
};

export default BookingLandingScreen;
